(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hr-deferred-gallery')) {
    customElements.define('hr-deferred-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('media-grid');
        this.button = this.querySelector('[data-gallery-more]');
        if (!this.grid || !this.button) return;
        this.expanded = false;
        this.desktop = window.matchMedia('(min-width: 700px)');
        this.syncPreview = () => {
          if (this.expanded) return;
          this.querySelectorAll('template[data-gallery-item]').forEach((item, index) => {
            if (index < 9) {
              if (this.desktop.matches) this.hydrate(item);
              if (item.galleryNode) item.galleryNode.hidden = !this.desktop.matches;
            }
          });
          this.button.hidden = !this.querySelector('template[data-gallery-item]:not([data-loaded])') && this.desktop.matches;
        };
        this.desktop.addEventListener('change', this.syncPreview);
        this.button.addEventListener('click', () => {
          this.expanded = true;
          let firstNew;
          this.querySelectorAll('template[data-gallery-item]').forEach(item => {
            if (!item.galleryNode || item.galleryNode.hidden) {
              const node = this.hydrate(item);
              node.hidden = false;
              firstNew = firstNew || node;
            }
          });
          this.button.setAttribute('aria-expanded', 'true');
          this.button.hidden = true;
          if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({preventScroll: true}); }
        });
        this.syncPreview();
      }
      hydrate(item) {
        if (item.galleryNode) return item.galleryNode;
        const node = item.content.firstElementChild.cloneNode(true);
        node.querySelectorAll('[reveal-on-scroll]').forEach(el => el.removeAttribute('reveal-on-scroll'));
        item.before(node);
        item.dataset.loaded = 'true';
        item.galleryNode = node;
        return node;
      }
      disconnectedCallback() { if (this.desktop && this.syncPreview) this.desktop.removeEventListener('change', this.syncPreview); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spectrum-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spectrum-landing')) {
    customElements.define('spectrum-landing', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.motionButton = this.querySelector('[data-motion-toggle]');
        this.videos = [...this.querySelectorAll('video.spectrum-motion-video')];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPaused = this.reducedMotion.matches;
        this.manifestDialog = this.querySelector('[data-manifest-dialog]');
        this.manifestClose = this.querySelector('[data-manifest-close]');
        this.dialogInner = this.querySelector('[data-dialog-inner]');
        this.contactButton = this.querySelector('[data-contact-open]');
        this.contactPanel = this.querySelector('[data-contact-panel]');
        this.contactClose = this.querySelector('[data-contact-close]');
        this.lastManifestTrigger = null;

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => entry.target.dataset.inView = String(entry.isIntersecting));
            this.updateVideos();
          }, { rootMargin: '120px 0px', threshold: .08 });
          this.videos.forEach((video) => {
            video.dataset.inView = 'false';
            this.videoObserver.observe(video);
          });
        } else {
          this.videos.forEach((video) => video.dataset.inView = 'true');
        }

        this.updateMotionState();
        this.motionButton?.addEventListener('click', () => {
          this.motionPaused = !this.motionPaused;
          this.updateMotionState();
        }, { signal });

        this.querySelectorAll('[data-manifest-open]').forEach((button) => {
          button.addEventListener('click', () => this.openManifesto(button), { signal });
        });
        this.manifestClose?.addEventListener('click', () => this.manifestDialog.close(), { signal });
        this.dialogInner?.addEventListener('click', (event) => {
          if (event.target === this.dialogInner) this.manifestDialog.close();
        }, { signal });
        this.manifestDialog?.addEventListener('close', () => this.lastManifestTrigger?.focus(), { signal });

        this.contactButton?.addEventListener('click', () => this.setContactOpen(this.contactButton.getAttribute('aria-expanded') !== 'true'), { signal });
        this.contactClose?.addEventListener('click', () => this.setContactOpen(false), { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.contactButton?.getAttribute('aria-expanded') === 'true') this.setContactOpen(false);
        }, { signal });
        if (this.contactPanel?.dataset.autoOpen === 'true') {
          requestAnimationFrame(() => this.contactPanel.querySelector('[data-contact-status], [role="alert"]')?.focus());
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.videoObserver?.disconnect();
        this.videos?.forEach((video) => video.pause());
      }

      openManifesto(trigger) {
        if (!this.manifestDialog || this.manifestDialog.open) return;
        this.lastManifestTrigger = trigger;
        this.manifestDialog.showModal();
        this.manifestClose?.focus();
      }

      updateMotionState() {
        this.classList.toggle('is-motion-paused', this.motionPaused);
        if (this.motionButton) {
          this.motionButton.setAttribute('aria-pressed', String(this.motionPaused));
          this.motionButton.textContent = this.motionPaused ? this.motionButton.dataset.playLabel : this.motionButton.dataset.pauseLabel;
        }
        this.updateVideos();
      }

      updateVideos() {
        this.videos?.forEach((video) => {
          if (this.motionPaused || video.dataset.inView === 'false') video.pause();
          else video.play().catch(() => {});
        });
      }

      setContactOpen(isOpen) {
        if (!this.contactPanel || !this.contactButton) return;
        this.contactPanel.classList.toggle('is-open', isOpen);
        this.contactPanel.setAttribute('aria-hidden', String(!isOpen));
        this.contactButton.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
          this.contactPanel.removeAttribute('inert');
          window.setTimeout(() => this.contactPanel.querySelector('input')?.focus(), this.reducedMotion.matches ? 0 : 420);
        } else {
          this.contactPanel.setAttribute('inert', '');
          this.contactButton.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
